/* eslint-disable @typescript-eslint/naming-convention */
import { clinicRoutes } from "@clinic/shared/data/clinicRoutes";

const practitionerRoutes = {
  ...clinicRoutes,
  legacyHome: "/p/stores",
  account: "/p/stores/account",
  peerReferrals: "/o/peer_referrals",
  legacyDashboard: "/p/stores/dashboard",
  dashboard: "/o/dashboard",
  referral: "/p/stores/referral",
  store_welcome: "/p/welcome",
  wrong_account_type: "/p/wrong-account-type",
  stock_locations: "/w/stock_locations",
  npSync: "/w/np-sync",
  taxEdit: "/w/tax/form/edit",
  onboardingCredentialsUpload: "/o/onboarding/credentials",
  onboardingNPIConfirmation: "/o/onboarding/npi-confirmation",
  storeSettings: {
    base: "/o/store_settings",
    features: "/o/store_settings/features",
    labs: "/o/store_settings/labs",
    landingPage: "/o/store_settings/landing_page",
    payments: "/o/store_settings/payments",
    paymentsEdit: "/o/store_settings/payments/edit",
    paymentsPayouts: "/o/store_settings/payments/payouts",
    permissions: "/o/store_settings/permissions",
    permissionsPatient: "/o/store_settings/permissions/patient",
    promotions: "/o/store_settings/promotions",
    storeInfo: "/o/store_settings/dispensary_info",
    websiteButtons: "/o/store_settings/website_buttons",
  },
  landingPagePreview: urlSlug => `/welcome/${urlSlug}?preview=true`,
  switch_accounts: "/accounts",
} as const;

export { practitionerRoutes };
